import { Navigate, RouteObject } from 'react-router-dom'
import MobileAppsPage from '../../../../pages/settings/platforms/MobileAppsPage'
import PlatformsPage from '../../../../pages/settings/platforms/PlatformsPage'
import WhatsAppPage from '../../../../pages/settings/platforms/WhatsappPage'

const platformsRoutes: RouteObject[] = [
  { path: 'list', element: <PlatformsPage /> },
  { path: 'mobile-apps', element: <MobileAppsPage /> },
  { path: 'whatsapp', element: <WhatsAppPage /> },
  { index: true, element: <Navigate to="list" replace /> },
  { path: '*', element: <Navigate to="/404" replace /> },
]

export default platformsRoutes
